/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ crm: NonNullable<unknown>, portal: NonNullable<unknown> }} Portals_Sync_Row_SummaryInputs */

const cs_portals_sync_row_summary = /** @type {(inputs: Portals_Sync_Row_SummaryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`CRM: ${i?.crm} · Portál: ${i?.portal}`)
};

const en_portals_sync_row_summary = /** @type {(inputs: Portals_Sync_Row_SummaryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`CRM: ${i?.crm} · Portal: ${i?.portal}`)
};

/**
* | output |
* | --- |
* | "CRM: {crm} · Portal: {portal}" |
*
* @param {Portals_Sync_Row_SummaryInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portals_sync_row_summary = /** @type {((inputs: Portals_Sync_Row_SummaryInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portals_Sync_Row_SummaryInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portals_sync_row_summary(inputs)
	return cs_portals_sync_row_summary(inputs)
});